import httpClient from '@/utils/httpClient'

import type { Step } from '@/questionnaire/types'

const stepsService = {
  fetchSteps: async (templateId: string): Promise<Step[]> => {
    const response = await httpClient.get<{ document_type: string; steps: Step[] }>(`/v1/templates/${templateId}/steps`)
    const steps = response.data.steps

    return steps
  },
}

export default stepsService
